export const discountsRoutes = {
  'api.discount.validation': 'discounts/coupon/evaluate-code',
  'api.discount.valid-codes': 'discounts/valid-codes',
};
